import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The prerendered HTML (for crawlers / social previews) is replaced by the live React app.
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
